(function () {

    'use strict';

    angular.module('app').controller('AdvanceExtractionModalController', AdvanceExtractionModalController);

    AdvanceExtractionModalController.$inject = [
        '$scope',
        'Location',
        '$timeout',
        '$uibModalInstance',
        '$uibModal',
        'Shipments',
        'TableTemplateUrls',
        'aborter',
        'TableLiteFactory',
        '$q',
        'Carrier',
        'ClientService',
        'isEmailExtractedFiles'
    ];

    function AdvanceExtractionModalController(
        $scope,
        Location,
        $timeout,
        $uibModalInstance,
        $uibModal,
        Shipments,
        TableTemplateUrls,
        aborter,
        TableLiteFactory,
        $q,
        Carrier,
        ClientService,
        isEmailExtractedFiles
    ) {
        let vm = this;
        vm.cancel = cancel;
        vm.extract = extract;
        vm.resetForm = resetForm;

        vm.headers = [
            {
                label: 'Created Date',
                viewName: 'createdDate',
                filterName: 'createdDate',
                filter: {
                    type: 'datePicker',
                    url: '',
                    class: 'filter-date',
                    toModel: '',
                    fromModel: '',
                    useArray: true,
                }
            }, {
                label: 'Manifested Date',
                viewName: 'manifestedDate',
                filterName: 'manifestedDate',
                filter: {
                    type: 'datePicker',
                    url: '',
                    class: 'filter-date',
                    toModel: '',
                    fromModel: '',
                    useArray: true,
                }
            }, {
                label: 'COMPANY',
                viewName: 'companyName',
                filterName: 'company',
                filter: {
                    type: 'multipleSelect',
                    placeholder: 'Search',
                    viewName: 'name',
                    filterBy: 'id',
                    items: [],
                    appendToBody: false,
                    position: 'auto',
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        ClientService.Company.getAll((data) => {
                            filterItems.length = 0;
                            angular.forEach(data.content, (profile) => {
                                filterItems.push(profile);
                            });
                            defer.resolve();
                        }, (error) => {
                            console.log(error);
                            defer.reject();
                        }, { size: 30, name: model });
                        return defer.promise;
                    }
                }
            }, {
                label: 'ACCOUNT',
                viewName: 'accountEmail',
                filterName: 'user.email',
                filter: {
                    type: 'autoComplete',
                    placeholder: 'Search',
                    viewName: 'email',
                    filterBy: 'id',
                    items: [],
                    appendToBody: false,
                    position: 'auto',
                    onSubmit: function (header) {
                        tableActions.sendRequest(tableActions.evaluateFilter(header));
                    },
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        ClientService.Account.getAll(data => {
                            filterItems.length = 0;
                            filterItems.push({
                                name: 'All Accounts',
                                value: 'null'
                            });
                            angular.forEach(data.content, account => {
                                filterItems.push(account);
                            });
                        }, error => {
                            console.log(error);
                            defer.reject();
                        }, { size: 30, email: model });
                        return defer.promise;
                    }
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'BOOKING STATUS',
                viewName: 'bookingStatus',
                filterName: 'bookingStatus',
                filter: {
                    type: 'multipleSelect',
                    placeholder: 'Search',
                    class: 'table-input',
                    items: [],
                    appendToBody: false,
                    position: 'auto',
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        $timeout(() => {
                            filterItems.length = 0;
                            let statuses = [{
                                value: 'pending',
                                viewName: 'Awaiting Booking'
                            }, {
                                value: 'inprogress',
                                viewName: 'Processing'
                            }, {
                                value: 'processed',
                                viewName: 'Completed'
                            }];
                            statuses.map((status) => filterItems.push(status));
                            defer.resolve();
                        }, (error) => {
                            console.log(error);
                            defer.reject();
                        }, { size: 30, name: model });
                        return defer.promise;
                    }
                }
            }, {
                label: 'CUBIC WEIGHT',
                viewName: 'cubicWeight',
                filter: {
                    type: 'select2',
                    placeholder: 'Search',
                    class: 'table-input',
                    items: [{
                        value: {
                            minCubicWeight: 0,
                            maxCubicWeight: 5
                        },
                        viewName: '0 Kg - 5 Kg'
                    }, {
                        value: {
                            minCubicWeight: 5,
                            maxCubicWeight: 10
                        },
                        viewName: '5 Kg - 10 Kg'
                    }, {
                        value: {
                            minCubicWeight: 10,
                            maxCubicWeight: 25
                        },
                        viewName: '10 Kg - 25 Kg'
                    }, {
                        value: {
                            minCubicWeight: 0,
                            maxCubicWeight: 10
                        },
                        viewName: '> 25 Kg'
                    }],
                },
                headerFn: function () {
                    tableActions.sort(this.filterName);
                }
            }, {
                label: 'CARRIER PROFILE',
                viewName: 'carrierProfileName',
                filterName: 'carrierProfileId',
                sortName: 'carrierProfile.id',
                filter: {
                    type: 'multipleSelect',
                    placeholder: 'Search',
                    viewName: 'name',
                    filterBy: 'id',
                    items: [],
                    appendToBody: false,
                    position: 'auto',
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        Carrier.carrierProfilesCompact((data) => {
                            filterItems.length = 0;
                            /*filterItems.push({
                                name: 'All carrier profiles',
                                value: 'null'
                            });*/
                            angular.forEach(data.content, (profile) => {
                                filterItems.push(profile);
                            });
                            defer.resolve();
                        }, (error) => {
                            console.log(error);
                            defer.reject();
                        }, { size: 30, name: model });
                        return defer.promise;
                    }
                }
            }, {
                label: 'SERVICE PROFILE',
                viewName: 'serviceProfileName',//to fix
                filterName: 'serviceProfileId',//to fix
                filter: {
                    type: 'multipleSelect',
                    placeholder: 'Search',
                    viewName: 'displayName',
                    filterBy: 'id',
                    appendToBody: false,
                    position: 'auto',
                    items: [], //List of items shown in dropdown
                    refresh: function (model) {
                        const defer = $q.defer();
                        let filterItems = this.items;
                        Carrier.serviceProfilesCompact((data) => {
                            /*filterItems.push({
                                name: 'All carrier profiles',
                                value: 'null'
                            });*/
                            filterItems.length = 0;
                            angular.forEach(data.content, (profile) => {
                                filterItems.push(profile);
                            });
                            defer.resolve();
                        }, (error) => {
                            console.log(error);
                            defer.reject();
                        }, { size: 30, name: model });
                        return defer.promise;
                    }
                }
            }];

        vm.getItemList = getItemList;
        vm.searchForSuburb = searchForSuburb;
        vm.countries = [];
        vm.size = 20;
        vm.templatesUrls = TableTemplateUrls;
        vm.viewList = ['All', 5, 10, 25, 50, 100, 500];
        $scope.refresh = refresh;
        $scope.onEnterKeyPress = onEnterKeyPress;

        $scope.datePickers = {};

        $scope.datePicker = {
            fromDate: {
                opened: false,
                options: {
                    formatYear: 'yy',
                    startingDay: 1
                },
                onChange: function (header) {
                    $scope.datePicker.toDate.options.minDate = new Date(header.filter.fromModel);
                    if (!header.filter.toModel) {
                        header.filter.toModel = new Date();
                    }
                    header.filter.onSubmit(header);
                }
            },
            toDate: {
                opened: false,
                options: {
                    formatYear: 'yy',
                    startingDay: 1
                },
                onChange: function (header) {
                    if (!header.filter.fromModel) {
                        header.filter.fromModel = new Date(0);
                    }
                    header.filter.onSubmit(header);
                }
            },
            openToDate: function () {
                $scope.datePicker.toDate.opened = true;
            },
            openFromDate: function () {
                $scope.datePicker.fromDate.opened = true;
            }
        };

        // TODO: 
        // need to remove this one here, 
        // I think this there is a better way of doing this
        const tableActions = new TableLiteFactory({ headers: [] },
            {
                serviceCallback: Shipments.export,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    if (isEmailExtractedFiles) {
                        $uibModalInstance.close(true);
                    } else {
                        download(data, 'export-shipment.csv', data.fileType);
                    }

                    $scope.ngDisabled = false;
                },
                postRequestErrorCallback: err => {
                    $scope.ngDisabled = false;
                },
                defaultFilters: {
                    sort: 'id,desc'
                }
            }
        );


        init();

        function init() {
            configureHeaders();
            getCountries();

            const dateFilters = vm.headers.filter(header => angular.getObjVal(header, 'filter.type') === 'datePicker');
            dateFilters.forEach(filter => {
                setDateFilters(filter.viewName);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

        function refresh(headerFilter, select) {
            if (!select.open && !headerFilter.refreshOnLoad) {
                return false;
            }
            $scope.autocompleteFetching = true;
            if (headerFilter.items)
                headerFilter.items.length = 0;
            aborter(() => {
                try {
                    headerFilter.refresh(select.search).then(() => {
                        $scope.autocompleteFetching = false;
                    });
                } catch (e) {
                    $scope.autocompleteFetching = false;
                }
            }, 500);
        }

        function onEnterKeyPress($event, header) {
            let keyCode = $event.which || $event.keyCode;
            if (keyCode === 13) {
                header.filter.onSubmit(header);
            }
        }

        function extract() {
            $scope.ngDisabled = true;
            if (vm.size === "All") {
                extractAllShipment();
                return;
            }

            const filters = createFilterPayload();
            filters.size = vm.size;
            tableActions.sendRequest(filters);
        }

        function createFilterPayload() {
            const filters = {};
            const headerData = {};

            vm.headers.forEach(header => {
                if (header.filter) {
                    if (header.viewName === 'cubicWeight') {
                        angular.extend(headerData, angular.getObjVal(header, 'filter.model.value'));
                    }
                    else {
                        angular.extend(headerData, tableActions.evaluateFilter(header));
                    }
                }
            });

            const headerKeys = Object.keys(headerData);
            for (let i = 0; i < headerKeys.length; i++) {
                const header = headerKeys[i];

                if (header === 'user.email') {
                    angular.extend(filters, { userId: headerData[header] });
                    continue;
                }

                if (header === 'createdDate') {
                    angular.extend(filters, { createdDateStart: headerData[header][0], createdDateEnd: headerData[header][1] });
                    continue;
                }

                if (header === 'manifestedDate') {
                    angular.extend(filters, { manifestedDateStart: headerData[header][0], manifestedDateEnd: headerData[header][1] });
                    continue;
                }

                if (header === 'company') {
                    angular.extend(filters, { companyIds: headerData[header] });
                    continue;
                }

                if (header === 'carrierProfileId') {
                    angular.extend(filters, { carrierProfileIds: headerData[header] });
                    continue;
                }

                if (header === 'serviceProfileId') {
                    angular.extend(filters, { serviceProfileIds: headerData[header] });
                    continue;
                }

                if (header === 'bookingStatus') {
                    const bookingStatus = headerData[header] ? headerData[header] : null;
                    if (!bookingStatus) { continue; }
                    const statuses = bookingStatus.map(status => {
                        return status.value;
                    });

                    angular.extend(filters, { bookingStatuses: statuses });
                    continue;
                }

                filters[header] = headerData[header];
            }

            angular.extend(filters, {
                sourceCountryCode: angular.getObjVal(vm.source, 'country.code'),
                sourceLocationId: angular.getObjVal(vm.source, 'id'),
                destinationCountryCode: angular.getObjVal(vm.destination, 'country.code'),
                destinationLocationId: angular.getObjVal(vm.destination, 'id')
            });

            return filters;
        }

        function resetForm() {
            vm.headers.forEach(header => {
                angular.forEach(['model', 'fromModel', 'toModel'], name => {
                    if (angular.getObjVal(header, 'filter.' + name)) {
                        header.filter[name] = null;
                    }
                });
            });
        }

        function getItemList(search) {
            let newCount = vm.viewList.slice();
            if (search && newCount.indexOf(search) === -1) {
                newCount.unshift(search);
            }
            return newCount;
        }

        function getCountries() {
            Location.Country({
                // name: model
            }, function (data) {
                vm.countries = data;
            }, function (err) {
            })
        }

        function searchForSuburb(select, options) {
            if (!select.open) {
                return false;
            }
            vm.searching = true;
            vm.postcodes = [];
            Location.locationEnabled({
                enabled: true,
                country: angular.getObjVal(options, 'country.code') || '',
                code: select.search,
                sort: 'code,asc'
            }, data => {
                vm.postcodes = buildStates(data.content);
            }, error => {
                toastr.warning('Unable to get suburbs', error.message);
            })
        }

        function buildStates(codes) {
            var distinctCodes = [];
            angular.forEach(codes, function (code, key) {

                if (codes[key - 1] && code.code == codes[key - 1].code) {
                    distinctCodes[distinctCodes.length - 1].suburbs.push(angular.copy(code));
                } else {
                    code.suburbs = [angular.copy(code)];
                    distinctCodes.push(angular.copy(code));
                }
            });
            return distinctCodes;
        }

        function extractAllShipment() {
            const filters = createFilterPayload();
            Shipments.export(res => {
                showNotificationMessage(
                    'CSV report extraction is underway.',
                    "Download your file from the notification bell once it's ready."
                );
                $uibModalInstance.dismiss();
            }, error => {}, filters);
        }

        function showNotificationMessage(title, message) {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'setting-modal',
                templateUrl: '/templates/modal/notification-modal.html',
                controller: 'NotificationModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    title: () => title,
                    message: () => message
                }
            });
        }

        function configureHeaders() {
            vm.headers.forEach(header => {
                if (header.filter) {
                    // header.filter.appendToBody = true;
                    header.filter.onSubmit = function () {
                    }
                }
            });
        }

        function setDateFilters(viewName) {
            $scope.datePickers[viewName] = {
                fromDate: {
                    opened: false,
                    options: {
                        formatYear: 'yy',
                        startingDay: 1,
                        maxDate: new Date()
                    },
                    onChange: function (header) {
                        $scope.datePickers[viewName].toDate.options.minDate = new Date(header.filter.fromModel);
                        if (!header.filter.toModel) {
                            header.filter.toModel = new Date();
                        }
                        header.filter.onSubmit(header);
                    }
                },
                toDate: {
                    opened: false,
                    options: {
                        formatYear: 'yy',
                        startingDay: 1,
                        maxDate: new Date()
                    },
                    onChange: function (header) {
                        if (!header.filter.fromModel) {
                            header.filter.fromModel = new Date(0);
                        }
                        header.filter.onSubmit(header);
                    }
                },
                openToDate: function () {
                    $scope.datePickers[viewName].toDate.opened = true;
                },
                openFromDate: function () {
                    $scope.datePickers[viewName].fromDate.opened = true;
                }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/shipment/AdvancedExtractionModalController.js